export default function CitiIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect width="39.999" height="39.999" rx="8" fill="white" />
      <path
        d="M13.757 26.321L13.6981 26.378C12.7743 27.3193 11.7052 27.8166 10.6039 27.8166C8.30395 27.8166 6.63551 26.0912 6.63551 23.7112C6.63551 21.3349 8.30395 19.6067 10.6039 19.6067C11.7052 19.6067 12.7743 20.1068 13.6981 21.0518L13.757 21.1079L15.2361 19.319L15.1965 19.2712C13.9666 17.8178 12.4902 17.1109 10.6756 17.1109C8.85643 17.1109 7.19074 17.7241 5.99203 18.8281C4.68668 20.025 4 21.7127 4 23.7112C4 25.7097 4.68668 27.4011 5.99203 28.598C7.19074 29.7084 8.85643 30.317 10.6756 30.317C12.4902 30.317 13.9666 29.6092 15.1965 28.1549L15.2361 28.1108L13.757 26.321Z"
        fill="#004685"
      />
      <path
        d="M16.7299 30.073H19.3424V17.3174H16.7299V30.073Z"
        fill="#004685"
      />
      <path
        d="M29.5779 27.3001C28.8802 27.7248 28.2321 27.9389 27.6493 27.9389C26.8045 27.9389 26.4221 27.4922 26.4221 26.4994V19.7309H29.0852V17.3298H26.4221V13.3604L23.862 14.732V17.3298H21.6521V19.7309H23.862V26.9305C23.862 28.8913 25.0239 30.2334 26.7595 30.2683C27.937 30.2913 28.6467 29.9402 29.0769 29.6828L29.1045 29.6653L29.7323 27.2054L29.5779 27.3001Z"
        fill="#004685"
      />
      <path
        d="M31.7404 30.073H34.3567V17.3174H31.7404V30.073Z"
        fill="#004685"
      />
      <path
        d="M35.8805 15.0815C33.4932 11.7004 29.5294 9.68359 25.4966 9.68359C21.4647 9.68359 17.5 11.7004 15.1173 15.0815L14.9941 15.2552H18.0001L18.0331 15.2194C20.0785 13.1069 22.7498 11.9909 25.4966 11.9909C28.2433 11.9909 30.9128 13.1069 32.9628 15.2194L32.9959 15.2552H36L35.8805 15.0815Z"
        fill="#EE1C25"
      />
    </svg>
  );
}
